export type Theme = 'dark' | 'light';

export const THEME_KEY = 'sourcetape-theme';
export const DEFAULT_THEME: Theme = 'light';

type StorageLike = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
};

type ClassTarget = { classList: { toggle(token: string, force?: boolean): boolean } };

function browserStorage(): StorageLike | null {
  try {
    const g = globalThis as { localStorage?: StorageLike };
    return g.localStorage ?? null;
  } catch {
    return null;
  }
}

export function parseTheme(value: unknown): Theme | null {
  return value === 'light' || value === 'dark' ? value : null;
}

export function readStoredTheme(storage: { getItem(key: string): string | null } = browserStorage() ?? { getItem: () => null }): Theme {
  try {
    return parseTheme(storage.getItem(THEME_KEY)) ?? DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function writeStoredTheme(theme: Theme, storage?: { setItem(key: string, value: string): void }): void {
  const store = storage ?? browserStorage();
  if (!store) return;
  try {
    store.setItem(THEME_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function applyDocumentTheme(theme: Theme, el?: ClassTarget): void {
  const target = el ?? (globalThis as { document?: { documentElement: ClassTarget } }).document?.documentElement;
  if (!target) return;
  target.classList.toggle('light', theme === 'light');
}

export function resolveTheme(stored: unknown, account: unknown): Theme {
  return parseTheme(account) ?? parseTheme(stored) ?? DEFAULT_THEME;
}
